<template>
	<div class="configdetails">
		<vx-card title="标准详情">
			<vs-breadcrumb :items="[{title: '企业文化标准',url: '/admin/configure'},{title: '标准配置详情',active: true}]"></vs-breadcrumb>
		</vx-card>
		<!-- 考核维度 -->
		<div class="mt-4 mr-10 ml-10 shadow-drop rounded-lg d-theme-dark-bg   text-lg font-medium" v-for="item in info" :key="item.dimension">
			<vx-card :title="item.dimension" class="mt-4" collapse-action>
				<vs-collapse open v-if="item">
					<vs-collapse-item v-for="(card,i) in item.templateInfoVo" :key="i">
						<div slot="header">
							{{i+1}}.{{card.behaviors}}
						</div>
					  <vx-input-group class="mb-base">
						<template slot="prepend">
						  <div class="prepend-text bg-primary">
							<span>序号</span>
						  </div>
						</template>
						<vs-input v-model="card.number"  />
					  </vx-input-group>
					  <vx-input-group class="mb-base">
						<template slot="prepend">
						  <div class="prepend-text bg-primary">
							<span>行为指标</span>
						  </div>
						</template>
						<vs-input v-model="card.behaviors" />
					  </vx-input-group>
					  <vx-input-group class="mb-base">
						<template slot="prepend">
						  <div class="prepend-text bg-primary">
							<span>行为标准</span>
						  </div>
						</template>
						<vs-textarea v-model="card.standards" />
					  </vx-input-group>
					  <vx-input-group class="mb-base">
						<template slot="prepend">
						  <div class="prepend-text bg-primary">
							<span>举证突出</span>
						  </div>
						</template>
						<vs-textarea v-model="card.prominentEvidence" />
					  </vx-input-group>
					  <vx-input-group class="mb-base">
						<template slot="prepend">
						  <div class="prepend-text bg-primary">
							<span>评分标准</span>
						  </div>
						</template>
						<vs-textarea v-model="card.markingCriterion" />
					  </vx-input-group>
					  <vx-input-group class="mb-base flex items-center justify-center">
						<template slot="prepend">
						  <div class="prepend-text bg-primary">
							<span>可选分值</span>
						  </div>
						</template>
						<ul class="flex items-center justify-center">
              <li><vs-checkbox v-model="card.optionalScore" vs-value="-5">-5分</vs-checkbox></li>
              <li><vs-checkbox v-model="card.optionalScore" vs-value="-4">-4分</vs-checkbox></li>
              <li><vs-checkbox v-model="card.optionalScore" vs-value="-3">-3分</vs-checkbox></li>
              <li><vs-checkbox v-model="card.optionalScore" vs-value="-2">-2分</vs-checkbox></li>
              <li><vs-checkbox v-model="card.optionalScore" vs-value="-1">-1分</vs-checkbox></li>
							<li><vs-checkbox v-model="card.optionalScore" vs-value="0">0分</vs-checkbox></li>
							<li><vs-checkbox v-model="card.optionalScore" vs-value="1">1分</vs-checkbox></li>
							<li><vs-checkbox v-model="card.optionalScore" vs-value="2">2分</vs-checkbox></li>
							<li><vs-checkbox v-model="card.optionalScore" vs-value="3">3分</vs-checkbox></li>
							<li><vs-checkbox v-model="card.optionalScore" vs-value="4">4分</vs-checkbox></li>
							<li><vs-checkbox v-model="card.optionalScore" vs-value="5">5分</vs-checkbox></li>
              <br/>
              <li><vs-checkbox v-model="card.optionalScore" vs-value="15">15分</vs-checkbox></li>
              <li><vs-checkbox v-model="card.optionalScore" vs-value="16">16分</vs-checkbox></li>
              <li><vs-checkbox v-model="card.optionalScore" vs-value="17">17分</vs-checkbox></li>
              <li><vs-checkbox v-model="card.optionalScore" vs-value="18">18分</vs-checkbox></li>
              <li><vs-checkbox v-model="card.optionalScore" vs-value="19">19分</vs-checkbox></li>
              <li><vs-checkbox v-model="card.optionalScore" vs-value="20">20分</vs-checkbox></li>
              <li><vs-checkbox v-model="card.optionalScore" vs-value="21">21分</vs-checkbox></li>
              <li><vs-checkbox v-model="card.optionalScore" vs-value="22">22分</vs-checkbox></li>
              <li><vs-checkbox v-model="card.optionalScore" vs-value="23">23分</vs-checkbox></li>
              <li><vs-checkbox v-model="card.optionalScore" vs-value="24">24分</vs-checkbox></li>
              <li><vs-checkbox v-model="card.optionalScore" vs-value="25">25分</vs-checkbox></li>

            </ul>
					  </vx-input-group>
					  <vs-divider color="primary" > 可选项(模板示例) </vs-divider>
					  <vx-input-group class="mb-base">
					  		<template slot="prepend">
					  			<div class="prepend-text bg-primary">
					  				<span>行为佐证提示</span>
					  				</div>
					  		</template>
							<vs-textarea v-model="card.evidenceTips" />
					  </vx-input-group>
					  <vx-input-group class="mb-base">
					  		<template slot="prepend">
					  			<div class="prepend-text bg-primary">
					  				<span>佐证来源提示</span>
					  				</div>
					  		</template>
					  		<vs-textarea v-model="card.evidenceSourceTips" />
					  </vx-input-group>
					</vs-collapse-item>
				</vs-collapse>
			</vx-card>
		</div>

		<!-- 操作 -->
		<div class="foot">
			<vs-row vs-type="flex" vs-justify="center">
			  <vs-col vs-type="flex" vs-justify="space-around" vs-align="center" vs-w="6">
			    <vs-button color="primary" type="filled" @click="save">保存</vs-button>
			    <vs-button color="rgb(62, 201, 214)" type="filled" @click="popupActive=true">新增项</vs-button>
			    <vs-button color="danger" type="filled" @click="popupDel=true">删除项</vs-button>
			  </vs-col>
			</vs-row>
		</div>
		<!-- 新增项弹窗 -->
		  <div class="demo-alignment">
		    <vs-popup classContent="popup-example" fullscreen  title="请补充新增项内容" :active.sync="popupActive">
				<vx-input-group class="mb-base">
				<template slot="prepend">
				  <div class="prepend-text bg-primary">
					<span>考核维度</span>
				  </div>
				</template>
				<vs-select v-model="itemconfig.dimensionType" class="w-full select-large">
          <vs-select-item  value="0" text="核心价值观"  class="w-full" />
          <vs-select-item  value="1" text="顾客至上"  class="w-full" />
					<vs-select-item  value="2" text="团队精神"  class="w-full" />
					<vs-select-item  value="3" text="追求卓越"  class="w-full" />
					<vs-select-item  value="4" text="长期坚持艰苦奋斗"  class="w-full" />
          <vs-select-item  value="5" text="倒扣分项"  class="w-full" />
				</vs-select>
				</vx-input-group>
		        <vx-input-group class="mb-base">
		      	<template slot="prepend">
		      	  <div class="prepend-text bg-primary">
		      		<span>序号</span>
		      	  </div>
		      	</template>
		      	<vs-input v-model="itemconfig.number" />
		        </vx-input-group>
		        <vx-input-group class="mb-base">
		      	<template slot="prepend">
		      	  <div class="prepend-text bg-primary">
		      		<span>行为指标</span>
		      	  </div>
		      	</template>
		      	<vs-input v-model="itemconfig.behaviors" />
		        </vx-input-group>
		        <vx-input-group class="mb-base">
		      	<template slot="prepend">
		      	  <div class="prepend-text bg-primary">
		      		<span>行为标准</span>
		      	  </div>
		      	</template>
		      	<vs-textarea v-model="itemconfig.standards" />
		        </vx-input-group>
		        <vx-input-group class="mb-base">
		      	<template slot="prepend">
		      	  <div class="prepend-text bg-primary">
		      		<span>举证突出</span>
		      	  </div>
		      	</template>
		      	<vs-textarea v-model="itemconfig.prominentEvidence" />
		        </vx-input-group>
		        <vx-input-group class="mb-base">
		      	<template slot="prepend">
		      	  <div class="prepend-text bg-primary">
		      		<span>评分标准</span>
		      	  </div>
		      	</template>
		      	<vs-textarea v-model="itemconfig.markingCriterion" />
		        </vx-input-group>
		        <vx-input-group class="mb-base">
		      	<template slot="prepend">
		      	  <div class="prepend-text bg-primary">
		      		<span>可选分值</span>
		      	  </div>
		      	</template>
		      	<ul class="flex items-center justify-center">
              <li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="-5">-5分</vs-checkbox></li>
              <li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="-4">-4分</vs-checkbox></li>
              <li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="-3">-3分</vs-checkbox></li>
              <li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="-2">-2分</vs-checkbox></li>
              <li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="-1">-1分</vs-checkbox></li>
              <li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="0">0分</vs-checkbox></li>
		      		<li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="1">1分</vs-checkbox></li>
		      		<li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="2">2分</vs-checkbox></li>
		      		<li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="3">3分</vs-checkbox></li>
		      		<li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="4">4分</vs-checkbox></li>
		      		<li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="5">5分</vs-checkbox></li>
              <br/>
              <li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="15">15分</vs-checkbox></li>
              <li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="16">16分</vs-checkbox></li>
              <li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="17">17分</vs-checkbox></li>
              <li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="18">18分</vs-checkbox></li>
              <li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="19">19分</vs-checkbox></li>
              <li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="20">20分</vs-checkbox></li>
              <li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="21">21分</vs-checkbox></li>
              <li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="22">22分</vs-checkbox></li>
              <li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="23">23分</vs-checkbox></li>
              <li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="24">24分</vs-checkbox></li>
              <li><vs-checkbox v-model="itemconfig.optionalScore" vs-value="25">25分</vs-checkbox></li>

            </ul>
		        </vx-input-group>
				<vs-divider color="primary" > 可选项(模板示例) </vs-divider>
				<vx-input-group class="mb-base">
						<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span>行为佐证提示</span>
								</div>
						</template>
						<vs-textarea v-model="itemconfig.evidenceTips" />
				</vx-input-group>
				<vx-input-group class="mb-base">
						<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span>佐证来源提示</span>
								</div>
						</template>
						<vs-textarea v-model="itemconfig.evidenceSourceTips" />
				</vx-input-group>
				<vs-row vs-type="flex" vs-justify="center">
					<vs-button color="rgb(62, 201, 214)" type="filled" @click="additem">新增</vs-button>
				</vs-row>
		    </vs-popup>
		  </div>
		  <!-- 删除项弹窗 -->
		  <div class="demo-alignment">
		    <vs-popup classContent="popup-example"   title="请选择要删除的项" :active.sync="popupDel">
		  		<vx-input-group class="mb-base">
		  			<template slot="prepend">
		  				<div class="prepend-text bg-primary"><span>考核维度</span></div>
		  			</template>
		  			<vs-select v-model="delconfig.dimensionType" class="select-large" style="width:80%">
		  				<vs-select-item  :value="index" :text="item.dimension"   v-for="(item,index) in info" :key="item.id" />
		  			</vs-select>
		  		</vx-input-group>
				<vx-input-group class="mb-base">
				<template slot="prepend">
				  <div class="prepend-text bg-primary">
					<span>项名称</span>
				  </div>
				</template>
				<vs-select v-model="delconfig.id" class="select-large" style="width:80%" :disabled="delconfig.isselect">
					<vs-select-item  :value="item.id" :text="item.behaviors"   v-for="item in delconfig.itemlist" :key="item.id"   />
				</vs-select>
				</vx-input-group>
		  		<vs-row vs-type="flex" vs-justify="center">
		  				<vs-button color="rgb(62, 201, 214)" type="filled" @click="delitem">删除</vs-button>
		  		</vs-row>
		    </vs-popup>
		  </div>
		
	</div>
	
</template>
<script>
	export default {
	    data() {
	        return {
				id:'',
				info:'',
				delconfig:{dimensionType:-1,isselect:true,id:'',itemlist:[]},
				itemconfig:{dimensionType:1,number:'',behaviors:'',standards:'',markingCriterion:'',evidenceSourceTips:'',evidenceTips:'',prominentEvidence:'',optionalScore:[]},    //新增项配置
				popupActive:false,  //弹窗控制
				popupDel:false,     //删除弹窗
			}
	    },
		mounted() {
			this.id=this.$route.query.id;
			this.getdetails();
		},
		watch:{
			'delconfig.dimensionType'(){
				this.delconfig.isselect=false;
				this.delconfig.id='';
				this.delconfig.itemlist=this.info[this.delconfig.dimensionType].templateInfoVo;
			},
		},
		methods:{
			save(){     //保存标准
				const that = this;
				var obj=that.info;
				for(var i=0;i<that.info.length;i++){
					for(var j=0;j<that.info[i].templateInfoVo.length;j++){
						obj[i].templateInfoVo[j].optionalScore=that.info[i].templateInfoVo[j].optionalScore.toString();					 
					}
				}
				console.log("保存标准",obj);
				this.$api.Configsave(obj,{'content-type':'application/json'}).then(function (response) {
					console.log("添加结果：",response);
					if(response.code==0){
						 that.$vs.notify({
							  title:"提示",
							  color:'success',
							  text:response.message,
							  position:'top-center'
						 });
						 that.getdetails();
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				})
			},
			getdetails(){   //获取详情
				const that = this;
				this.$api.Configdetails({templateId :that.id}).then(function (response) {
					console.log("详情：",response);
					if(response.code==0){
						 that.info=response.data;
						 for(var i=0;i<that.info.length;i++){
							 for(var j=0;j<that.info[i].templateInfoVo.length;j++){
							 	that.info[i].templateInfoVo[j].optionalScore=that.info[i].templateInfoVo[j].optionalScore?that.info[i].templateInfoVo[j].optionalScore.split(","):[];					 
							 }
						 }
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				})
			},
			additem(){   //新增项
				console.log("新增项",this.itemconfig);
				const that = this;
				var obj=that.itemconfig;
				obj.templateId=that.id;
				obj.optionalScore=obj.optionalScore.toString();
				this.$api.Configadditem(obj).then(function (response) {
					console.log("添加结果：",response);
					if(response.code==0){
						 that.$vs.notify({
							  title:"提示",
							  color:'success',
							  text:response.message,
							  position:'top-center'
						 });
						 that.popupActive=false;
						 that.itemconfig={dimensionType:1,number:'',behaviors:'',standards:'',evidenceSourceTips:'',evidenceTips:'',markingCriterion:'',prominentEvidence:'',optionalScore:[]}
						 that.getdetails();
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				})
			},
			delitem(){   //删除项
				const that = this;
				if(!that.delconfig.id){
					that.$vs.notify({
						title:"提示",
						color:'warning',
						text:"请选择你要删除的项",
						position:'top-center'
					});
					return false;
				}
				this.$api.Configdelitem({id:that.delconfig.id}).then(function (response) {
					console.log("删除结果：",response);
					if(response.code==0){
						 that.$vs.notify({
							  title:"提示",
							  color:'success',
							  text:response.message,
							  position:'top-center'
						 });
						 that.delconfig={dimensionType:-1,isselect:true,id:'',itemlist:[]};
						 that.getdetails();
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				})
			},
		},
	}
</script>
<style type="text/css" scoped="scoped">
	.configdetails{
		min-height: 100vh;
		padding-bottom: 120px;
	}
	.configdetails .foot{
		position: fixed;
		bottom: 0;
		display: flex;
		justify-content: space-between;
		width: 100%;
		/* padding: 30px 40%; */
		height: 100px;
		background: #fff;
	}
</style>
